import { createContext } from 'react'
import type { Lang, TranslationKey } from './dictionaries'

export type Translate = (key: TranslationKey, vars?: Record<string, string | number>) => string

export interface LanguageValue {
  lang: Lang
  setLang: (lang: Lang) => void
  t: Translate
}

export const LanguageContext = createContext<LanguageValue | null>(null)
